import React, { useState } from "react";
import { CURL_RAW, CURL_HTML } from "../data/curl";

// Dark code window for the UPI Collect Request cURL example (copies the complete command).
export default function CurlPanel() {
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(CURL_RAW);
    } catch (e) {
      window.prompt("Copy this command", CURL_RAW);
    }
    setCopied(true);
    setTimeout(() => setCopied(false), 1800);
  };
  return (
    <div className="ced">
      <div className="edh">
        <i /><i /><i />
        <span className="mbadge">POST</span>
        <span className="fn">upi-collect-request.sh</span>
        <span className="lang">cURL</span>
        <button type="button" className="cp" onClick={copy} aria-label="Copy cURL command to clipboard">{copied ? "Copied" : "Copy Code"}</button>
      </div>
      <pre className="curlpre" tabIndex={0} aria-label="UPI Collect Request cURL example" dangerouslySetInnerHTML={{ __html: CURL_HTML }} />
    </div>
  );
}
